module.exports = __webpack_public_path__ + "img/disconnect.b6dec918.png";